
import { DashboardMenu } from "../../data/menu"
import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";
import { config } from "../../data/config";
import ImageUploader from "../tools/uploaderImage"
import { useTranslation } from 'react-i18next';
import HeaderOfPage from "../tools/headerOfPage";
export default function InvoiceList() {
    const { t } = useTranslation();

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'َکاربران',
            url: '/dashboard/user'
        },
        {
            name: 'لیست فاکتورها',
            url: null
        },
    ]
    const reloadgame = () => {
        setKey((prev: number) => prev + 1);
    }
    const [key, setKey] = useState<any>(1);

    return (
        <div className="bg-gray-50 min-h-screen p-4 md:p-6">
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="لیست فاکتورها"></HeaderOfPage>

            <div className="mt-6">
                <ListofBlog key={key}></ListofBlog>
            </div>
        </div>
    )
}
function ListofBlog() {
    const { t } = useTranslation();

    let cookie = getCookies();
    const [list, setList] = useState<any>(null);
    const [filteredDocs, setFilteredDocs] = useState<any[]>([]);
    const [search, setSearch] = useState<string>('');
    const [page, setPage] = useState<any>(1);

    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState<any>(1);
    const [loading, setLoading] = useState<boolean>(false);

    const getalldata = async () => {
        setError(null);

        try {
            setLoading(true);
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/invoices?page=' + page,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            const message = res.data.message;
            setList(message);
            setFilteredDocs(message?.docs || []);
        } catch (error: any) {

            // error.response.data.code != null && Swal.fire(` "${data.url}" slug is available.`);
            //  setError(error.response.data.message.errors);
        } finally {
            setLoading(false);
        }
    }
    const deleted = async (id: any) => {

        Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this Group!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, delete it!"),
            cancelButtonText: t('cancel'),
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/menus/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    })

                    getalldata();
                } catch (error) {
                    Swal.fire(t('Can not be to deleted, this item have submenu'))
                }
            }
        });

    }
    const toJalali = (date: string) => {
        const utcDate = new Date(date);
        const localDate = utcDate.toLocaleString('fa-IR', {

            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'

        }); // Converts to local time
        return localDate;


    }
    useEffect(() => {
        getalldata();
    }, [page]);

    useEffect(() => {
        if (!list) return;
        if (!search) {
            setFilteredDocs(list.docs || []);
        } else {
            const s = search.toLowerCase();
            setFilteredDocs(
                (list.docs || []).filter((item: any) => {
                    const name = item.touser?.name || '';
                    const mobile = item.touser?.mobile || '';
                    return (
                        name.toLowerCase().includes(s) ||
                        mobile.toLowerCase().includes(s)
                    );
                })
            );
        }
    }, [search, list]);

    return (
        <div className="directions text-right" dir="rtl">
            <div className="bg-white rounded-xl shadow-sm p-4 md:p-6">
                {/* top bar: search + reload */}
                <div className="flex flex-col md:flex-row items-center justify-between gap-3 mb-4">
                    <div className="flex gap-2 w-full md:w-auto">
                        <button
                            type="button"
                            onClick={getalldata}
                            className="inline-flex items-center gap-x-2 px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v6h6M20 20v-6h-6M5 19a9 9 0 0114-7.5M19 5a9 9 0 00-14 7.5" />
                            </svg>
                            {t('Reload')}
                        </button>
                    </div>
                    <div className="w-full md:w-72">
                        <input
                            type="text"
                            className="py-2.5 px-3 block w-full border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="جستجو بر اساس نام یا شماره همراه..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                </div>

                {loading ? (
                    <div className="flex items-center justify-center py-10">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                    </div>
                ) : (
                    <>
                        <div className="flex flex-col">
                            <div className="-m-1.5 overflow-x-auto">
                                <div className="p-1.5 min-w-full inline-block align-middle">
                                    <div className="overflow-hidden border border-gray-200 rounded-xl">
                                        <table className="min-w-full divide-y divide-gray-200 text-xs">
                                            <thead className="bg-gray-50">
                                                <tr>
                                                    <th scope="col" className="px-6 py-3 text-right text-[11px] font-semibold text-gray-500 uppercase tracking-wider">
                                                        {t('Name')}
                                                    </th>
                                                    <th scope="col" className="px-6 py-3 text-right text-[11px] font-semibold text-gray-500 uppercase tracking-wider">
                                                        {t('شماره همراه')}
                                                    </th>
                                                    <th scope="col" className="px-6 py-3 text-right text-[11px] font-semibold text-gray-500 uppercase tracking-wider">
                                                        {t('تاریخ')}
                                                    </th>
                                                    <th scope="col" className="px-6 py-3 text-right text-[11px] font-semibold text-gray-500 uppercase tracking-wider">
                                                        {t('قیمت کل')}
                                                    </th>
                                                    <th scope="col" className="px-6 py-3 text-right text-[11px] font-semibold text-gray-500 uppercase tracking-wider">
                                                        {t('وضعیت')}
                                                    </th>
                                                    <th scope="col" className="px-6 py-3 text-center text-[11px] font-semibold text-gray-500 uppercase tracking-wider">
                                                        {t('Action')}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-100">
                                                {filteredDocs.map((item: any) => (
                                                    item.touser && (
                                                        <tr key={item.id} className="hover:bg-gray-50">
                                                            <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">
                                                                {item.touser.name}
                                                            </td>
                                                            <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">
                                                                {item.touser.mobile}
                                                            </td>
                                                            <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">
                                                                {toJalali(item.createdAt)}
                                                            </td>
                                                            <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">
                                                                {item.totalprice.toLocaleString('fa-IR')} تومان
                                                            </td>
                                                            <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">
                                                                {item.status == "pending" && "در حال بررسی"}
                                                                {item.status == "paid" && "پرداخت شده"}
                                                                {item.status == "canceled" && "کنسل شده"}
                                                                {item.status == "sending" && "در حال ارسال"}
                                                            </td>
                                                            <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800 text-center">
                                                                <a href={`/dashboard/User/invoices/${item.id}`}>
                                                                    <img src="/icons/eye.svg" width={20} alt="View" className="inline-block" />
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    )
                                                ))}

                                                {(!filteredDocs || filteredDocs.length === 0) && (
                                                    <tr>
                                                        <td colSpan={6} className="px-6 py-6 text-center text-sm text-gray-500">
                                                            فاکتوری برای نمایش وجود ندارد.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Pagination */}
                        <div className="mt-4">
                            <nav className="flex items-center justify-center gap-1" aria-label="Pagination">
                                {list != null && list.prevPage != null && (
                                    <button
                                        onClick={() => setPage(list.page - 1)}
                                        type="button"
                                        className="min-h-[32px] min-w-[32px] py-1.5 px-2 inline-flex justify-center items-center gap-x-1.5 text-xs rounded-lg border border-gray-200 text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none"
                                        aria-label="Previous"
                                    >
                                        <svg className="shrink-0 w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m15 18-6-6 6-6" />
                                        </svg>
                                        <span className="hidden sm:block">{t('Previous')}</span>
                                    </button>
                                )}

                                {list != null &&
                                    Array.from({ length: list.totalPages }, (_, index) => index + 1).map((item) =>
                                        list.page === item ? (
                                            <button
                                                key={item}
                                                type="button"
                                                className="min-h-[32px] min-w-[32px] flex justify-center items-center bg-gray-200 text-gray-800 border border-gray-200 py-1.5 px-3 text-xs rounded-lg focus:outline-none"
                                                aria-current="page"
                                            >
                                                {item}
                                            </button>
                                        ) : (
                                            <button
                                                key={item}
                                                onClick={() => setPage(item)}
                                                type="button"
                                                className="min-h-[32px] min-w-[32px] flex justify-center items-center border border-gray-200 text-gray-800 hover:bg-gray-100 py-1.5 px-3 text-xs rounded-lg focus:outline-none"
                                            >
                                                {item}
                                            </button>
                                        )
                                    )}

                                {list != null && list.nextPage != null && (
                                    <button
                                        onClick={() => setPage(list.page + 1)}
                                        type="button"
                                        className="min-h-[32px] min-w-[32px] py-1.5 px-2 inline-flex justify-center items-center gap-x-1.5 text-xs rounded-lg border border-gray-200 text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none"
                                        aria-label="Next"
                                    >
                                        <span className="hidden sm:block">{t('Next')}</span>
                                        <svg className="shrink-0 w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m9 18 6-6-6-6" />
                                        </svg>
                                    </button>
                                )}
                            </nav>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}
